/* eslint-disable import/order */
import {
  Chip,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import React from 'react'

import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../../components/hooks/BaseTableComponents'
import { dateFormatedFullDate } from '../../../../util/utils'

const HistoryItemsTable = ({ items = [] }) => {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellHeader align="left">Data</StyledTableCellHeader>

            <StyledTableCellHeader align="left">Usuário</StyledTableCellHeader>

            <StyledTableCellHeader align="center">Status</StyledTableCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, index) => (
            <TableRow key={index} hover>
              <StyledTableCellBody align="left">
                {item?.created_at
                  ? dateFormatedFullDate(item?.created_at)
                  : '-'}
              </StyledTableCellBody>
              <StyledTableCellBody align="left">
                {item?.user?.name || '-'}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                <Chip
                  size="small"
                  label={item?.status?.name || '-'}
                  style={{
                    backgroundColor: item?.status?.color,
                    borderRadius: '8px',
                    fontSize: '14px',
                    color: '#FFFF',
                  }}
                />
              </StyledTableCellBody>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default HistoryItemsTable
